import { getDashboardPartnerGroupsControllerListQueryKey } from "@/api/__generated__/dashboard-partner-groups/dashboard-partner-groups";
import { PARTNERS_INVALIDATE_KEYS } from "@/constants/partner.constants";

/**
 * Query keys to invalidate after any partner-group mutation (create / update /
 * delete). The group list key is passed without params so react-query
 * prefix-matches every scoped variation (platform / organization / league).
 *
 * The partner list is included too because a group mutation changes the group a
 * partner is shown under (and deleting a group with `deletePartners` removes
 * partners), so the partners list must refetch as well.
 */
export const PARTNER_GROUPS_INVALIDATE_KEYS = [
  getDashboardPartnerGroupsControllerListQueryKey(),
  ...PARTNERS_INVALIDATE_KEYS,
];
